"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  SchoolBook: ['school-book', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M18.75,23.25H3A2.25,2.25,0,0,1,.75,21', 'M18.75.75h-15a3,3,0,0,0-3,3V21A2.25,2.25,0,0,1,3,18.75H18.75', 'M17.25 23.25L17.25 18.75', 'M5.25,12.75v-6a1.5,1.5,0,0,1,3,0v6', 'M5.25 9.75L8.25 9.75', 'M12.75 15.75L12.75 8.25', 'M12.75,8.25h1.5a1.5,1.5,0,0,1,1.5,1.5v.75a1.5,1.5,0,0,1-1.5,1.5h-1.5', 'M12.75,12h1.5a1.5,1.5,0,0,1,1.5,1.5v.75a1.5,1.5,0,0,1-1.5,1.5h-1.5', 'M23.25,5.25a3,3,0,0,0-3,3v1.5a3,3,0,0,0,3,3']],
  SchoolLocker: ['school-locker', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 0.750 L23.250 0.750 L23.250 23.250 L0.750 23.250 Z', 'M12 0.75L12 23.25', 'M0.75 12L23.25 12', 'M9 5.25L9 7.5', 'M9 16.5L9 18.75', 'M20.25 16.5L20.25 18.75', 'M12 5.25L15 5.25 15 12', 'M15 5.25L18 5.25 18 12', 'M21 12L18 5.25 21 3.75 23.25 9']],
  SchoolLocker1: ['school-locker-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5',
    transform: 'translate(36 15.75) rotate(-180)'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M1.75,2.25H19.5a0,0,0,0,1,0,0v19.5a0,0,0,0,1,0,0H1.75a1,1,0,0,1-1-1V3.25A1,1,0,0,1,1.75,2.25Z', 'M9.75 2.25L9.75 21.75', 'M3.75 18L6.75 18', 'M3.75 15L6.75 15', 'M3.75 8.25L6.75 8.25', 'M3.75 5.25L6.75 5.25', 'M9.75 10.5L19.5 10.5', 'M14.75,16.5H19.5a0,0,0,0,1,0,0v5.25a0,0,0,0,1,0,0H14.25a0,0,0,0,1,0,0V17A.5.5,0,0,1,14.75,16.5Z', 'M9.75,13.5H16.5c.414,0,.75.241.75.539V16.5', 'M9.75,5.25h2.5a.5.5,0,0,1,.5.5V10.5a0,0,0,0,1,0,0h-3a0,0,0,0,1,0,0V5.25A0,0,0,0,1,9.75,5.25Z', 'M16.5,5.25h3a0,0,0,0,1,0,0V10a.5.5,0,0,1-.5.5H16.5a0,0,0,0,1,0,0V5.25a0,0,0,0,1,0,0Z', 'M22.707,23.211,19.5,21.75V2.25L22.707.789a.375.375,0,0,1,.543.33V22.881A.375.375,0,0,1,22.707,23.211Z', 'M12.75 7.5L16.5 7.5']],
  SchoolLockerClosed: ['school-locker-closed', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M3.000 0.750 L21.000 0.750 L21.000 23.250 L3.000 23.250 Z', 'M12 0.75L12 23.25', 'M6 3.75L9 3.75', 'M6 6.75L9 6.75', 'M6 17.25L9 17.25', 'M6 20.25L9 20.25', 'M15 3.75L18 3.75', 'M15 6.75L18 6.75', 'M15 17.25L18 17.25', 'M15 20.25L18 20.25', 'M6 10.5L6 12', 'M15 10.5L15 12']],
  SchoolBoardChemistry: ['school-board-chemistry', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-miterlimit': '10',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M21.75,12V1.8A1.04,1.04,0,0,0,20.724.75H3.276A1.04,1.04,0,0,0,2.25,1.8V12', 'M3 18L3 23.25', 'M21 18L21 23.25', 'M3 21L21 21', 'M9.439,6.063,7.751,5.3a.614.614,0,0,0-.5,0l-1.688.76a.506.506,0,0,0-.311.454V8.4a.5.5,0,0,0,.306.451l1.944.9,1.944-.9A.5.5,0,0,0,9.75,8.4V6.517A.506.506,0,0,0,9.439,6.063Z', 'M12.75 10.045L9.398 8.877', 'M7.5 9.75L7.5 12', 'M15 7.5L15 5.25', 'M17.25 3.75L18.75 3.75', 'M21.506,18H2.494a1.522,1.522,0,0,1-1.483-1.136l-.238-.932A.754.754,0,0,1,1.515,15h20.97a.754.754,0,0,1,.742.932l-.238.932A1.522,1.522,0,0,1,21.506,18Z', 'M13.061,11.186l1.687.76a.609.609,0,0,0,.5,0l1.688-.76a.5.5,0,0,0,.311-.453V8.849a.5.5,0,0,0-.306-.45L15,7.5l-1.944.9a.5.5,0,0,0-.306.45v1.884A.5.5,0,0,0,13.061,11.186Z']],
  SchoolBell: ['school-bell', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M4.75 15L19.75 15', 'M19.75,15a1.72,1.72,0,0,1-1.5-1.5V9.75c0-3.75-2.562-7.068-6-7.068S6.25,6,6.25,9.75V13.5A1.72,1.72,0,0,1,4.75,15', 'M15.25,15a3,3,0,0,1-6,0', 'M12.25 2.682L12.25 0.75', 'M12.25 18L12.25 20.25', 'M10.750 21.750 A1.500 1.500 0 1 0 13.750 21.750 A1.500 1.500 0 1 0 10.750 21.750 Z']],
  SchoolExamA: ['school-exam-a', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M23.25,10.5v3.129a1.5,1.5,0,0,1-.439,1.061l-8.122,8.121a1.5,1.5,0,0,1-1.06.439H2.25a1.5,1.5,0,0,1-1.5-1.5V2.25A1.5,1.5,0,0,1,2.25.75h13.5', 'M14.25,23.115V15.75a1.5,1.5,0,0,1,1.5-1.5h7.365', 'M18.75,8.25v-6a1.5,1.5,0,0,1,3,0v6', 'M18.75 5.25L21.75 5.25', 'M7.5 6.75L12.75 6.75', 'M4.5 11.25L12.75 11.25', 'M4.5 15.75L10.5 15.75']],
  SchoolExamFFail: ['school-exam-f-fail', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M18.75,8.25v-6a1.5,1.5,0,0,1,1.5-1.5h1.5', 'M18.75 5.25L21 5.25', 'M23.25,10.5v3.129a1.5,1.5,0,0,1-.439,1.06l-8.122,8.122a1.5,1.5,0,0,1-1.06.439H2.25a1.5,1.5,0,0,1-1.5-1.5V2.25A1.5,1.5,0,0,1,2.25.75h13.5', 'M14.25,23.115V15.75a1.5,1.5,0,0,1,1.5-1.5h7.365', 'M7.5 6.75L12.75 6.75', 'M4.5 11.25L12.75 11.25', 'M4.5 15.75L10.5 15.75']],
  SchoolTeacherBraille: ['school-teacher-braille', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M2.250 3.750 A3.000 3.000 0 1 0 8.250 3.750 A3.000 3.000 0 1 0 2.250 3.750 Z', 'M5.25 8.25L5.25 14.25', 'M7.5,23.25l.75-7.5h1.5v-3a4.5,4.5,0,0,0-9,0v3h1.5L3,23.25Z', 'M23.25 0.75L11.25 0.75', 'M12.75 16.5L23.25 16.5', 'M13.875,3.75a.375.375,0,0,1,.375.375', 'M13.5,4.125a.375.375,0,0,1,.375-.375', 'M13.875,4.5a.375.375,0,0,1-.375-.375', 'M14.25,4.125a.375.375,0,0,1-.375.375', 'M13.875,8.25a.375.375,0,0,1,.375.375', 'M13.5,8.625a.375.375,0,0,1,.375-.375', 'M13.875,9a.375.375,0,0,1-.375-.375', 'M14.25,8.625A.375.375,0,0,1,13.875,9', 'M13.875,12.75a.375.375,0,0,1,.375.375', 'M13.5,13.125a.375.375,0,0,1,.375-.375', 'M13.875,13.5a.375.375,0,0,1-.375-.375', 'M14.25,13.125a.375.375,0,0,1-.375.375', 'M19.875,8.25a.375.375,0,0,1,.375.375', 'M19.5,8.625a.375.375,0,0,1,.375-.375', 'M19.875,9a.375.375,0,0,1-.375-.375', 'M20.25,8.625A.375.375,0,0,1,19.875,9', 'M19.875,3.75a.375.375,0,0,1,.375.375', 'M19.5,4.125a.375.375,0,0,1,.375-.375', 'M19.875,4.5a.375.375,0,0,1-.375-.375', 'M20.25,4.125a.375.375,0,0,1-.375.375']],
  SchoolTeacherA: ['school-teacher-a', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M2.250 3.750 A3.000 3.000 0 1 0 8.250 3.750 A3.000 3.000 0 1 0 2.250 3.750 Z', 'M5.25 8.25L5.25 14.25', 'M7.5,23.25l.75-7.5h1.5v-3a4.5,4.5,0,0,0-9,0v3h1.5L3,23.25Z', 'M23.25 0.75L11.25 0.75', 'M12.75 16.5L23.25 16.5', 'M16.5,12V6a1.5,1.5,0,0,1,3,0v6', 'M16.5 9L19.5 9']],
  SchoolTeacherWrong: ['school-teacher-wrong', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M2.250 3.750 A3.000 3.000 0 1 0 8.250 3.750 A3.000 3.000 0 1 0 2.250 3.750 Z', 'M5.25 8.25L5.25 14.25', 'M7.5,23.25l.75-7.5h1.5v-3a4.5,4.5,0,0,0-9,0v3h1.5L3,23.25Z', 'M23.25 0.75L11.25 0.75', 'M12.75 16.5L23.25 16.5', 'M15 11.25L20.25 6', 'M15 6L20.25 11.25']],
  SchoolTeacherPhysicalEducation: ['school-teacher-physical-education', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M2.250 3.750 A3.000 3.000 0 1 0 8.250 3.750 A3.000 3.000 0 1 0 2.250 3.750 Z', 'M5.25 8.25L5.25 14.25', 'M7.5,23.25l.75-7.5h1.5v-3a4.5,4.5,0,0,0-9,0v3h1.5L3,23.25Z', 'M23.25 0.75L11.25 0.75', 'M12.75 16.5L23.25 16.5', 'M17.281,7.362l.263-1.709a2.115,2.115,0,0,1,3.028,0,2.053,2.053,0,0,1,0,2.99l-1.551.437', 'M20.572,8.643s1.515-.748,1.893,1.121c.266,1.312-.447,1.2-5.416,2.583', 'M17.544,5.653s.757-1.495-1.136-1.869c-1.391-.274-1.309.659-2.49,5.472', 'M17.049,12.347l-.522.515a2.239,2.239,0,0,1-3.131,0h0a2.172,2.172,0,0,1,0-3.091l.522-.515Z']],
  SchoolTestMusical: ['school-test-musical', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M7.5,20.25H2.25a1.5,1.5,0,0,1-1.5-1.5V2.25A1.5,1.5,0,0,1,2.25.75H12.879a1.5,1.5,0,0,1,1.06.439l2.872,2.872a1.5,1.5,0,0,1,.439,1.06V11.25', 'M20.25 18.375L20.25 22.333 17.25 23.25 14.25 22.333 14.25 18.375', 'M23.25 17.25L17.25 15 11.25 17.25 17.25 19.5 23.25 17.25z', 'M11.25 17.25L11.25 20.25', 'M5.250 12.750 A1.500 1.500 0 1 0 8.250 12.750 A1.500 1.500 0 1 0 5.250 12.750 Z', 'M8.25,12.75V5.66A.476.476,0,0,1,9,5.333L12,7.3']],
  SchoolTeacherMaths: ['school-teacher-maths', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M2.250 3.750 A3.000 3.000 0 1 0 8.250 3.750 A3.000 3.000 0 1 0 2.250 3.750 Z', 'M5.25 8.25L5.25 14.25', 'M7.5,23.25l.75-7.5h1.5v-3a4.5,4.5,0,0,0-9,0v3h1.5L3,23.25Z', 'M23.25 0.75L11.25 0.75', 'M12.75 16.5L23.25 16.5', 'M11.25 6.75L12.75 8.25 13.5 3.75 17.25 3.75', 'M17.25 10.5L22.5 10.5', 'M19.875,12.75a.375.375,0,0,1,.375.375', 'M19.5,13.125a.375.375,0,0,1,.375-.375', 'M19.875,13.5a.375.375,0,0,1-.375-.375', 'M20.25,13.125a.375.375,0,0,1-.375.375', 'M19.875,7.5a.375.375,0,0,1,.375.375', 'M19.5,7.875a.375.375,0,0,1,.375-.375', 'M19.875,8.25a.375.375,0,0,1-.375-.375', 'M20.25,7.875a.375.375,0,0,1-.375.375']],
  SchoolTeacherArt: ['school-teacher-art', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M2.250 3.750 A3.000 3.000 0 1 0 8.250 3.750 A3.000 3.000 0 1 0 2.250 3.750 Z', 'M5.25 8.25L5.25 14.25', 'M7.5,23.25l.75-7.5h1.5v-3a4.5,4.5,0,0,0-9,0v3h1.5L3,23.25Z', 'M23.25 0.75L11.25 0.75', 'M12.75 16.5L23.25 16.5', 'M18.635,3.839a7.18,7.18,0,0,0-1.688-.2c-2.721,0-5.293,1.776-5.682,3.86-.443,2.377,1.6,4.056,2.985,4.5a2.061,2.061,0,0,0,2.43-.97', 'M20.164 10.265L18.172 14.25', 'M19.368,8.258a1.448,1.448,0,0,0,2.59,1.3,3.088,3.088,0,0,0-.648-4.1C21.526,7.178,20.231,6.531,19.368,8.258Z', 'M14.577,8.14a.375.375,0,0,1,.375.375', 'M14.2,8.515a.375.375,0,0,1,.375-.375', 'M14.577,8.89a.375.375,0,0,1-.375-.375', 'M14.952,8.515a.375.375,0,0,1-.375.375', 'M17.577,5.89a.375.375,0,0,1,.375.375', 'M17.2,6.265a.375.375,0,0,1,.375-.375', 'M17.577,6.64a.375.375,0,0,1-.375-.375', 'M17.952,6.265a.375.375,0,0,1-.375.375']],
  SchoolBoardMaths: ['school-board-maths', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 0.750 L23.250 0.750 L23.250 15.750 L0.750 15.750 Z', 'M3.75 15.75L3.75 23.25', 'M20.25 15.75L20.25 23.25', 'M3.75 20.25L20.25 20.25', 'M4.5,6.75A1.5,1.5,0,0,1,6,5.25H6a1.5,1.5,0,0,1,1.5,1.5h0a2.139,2.139,0,0,1-.468,1.336L4.5,11.25h3', 'M17.25,5.25H18a.75.75,0,0,1,.75.75v5.25', 'M17.25 11.25L20.25 11.25', 'M10.5 8.25L15 8.25', 'M12.75 6L12.75 10.5']],
  SchoolTestResults: ['school-test-results', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M5.25,20.25h-3a1.5,1.5,0,0,1-1.5-1.5V2.25A1.5,1.5,0,0,1,2.25.75H12.879a1.5,1.5,0,0,1,1.06.439l2.872,2.872a1.5,1.5,0,0,1,.439,1.06V9.75', 'M20.25 17.583L20.25 22.167 16.5 23.25 12.75 22.167 12.75 17.583', 'M23.25 16.65L16.5 14.19 9.75 16.65 16.5 18.75 23.25 16.65z', 'M9.75 16.65L9.75 20', 'M3.75 4.5L5.25 4.5', 'M8.25 4.5L12.75 4.5', 'M3.75 8.25L5.25 8.25', 'M8.25 8.25L12.75 8.25', 'M3.75 12L5.25 12', 'M3.75 15.75L5.25 15.75', 'M8.25 12L12.75 12']],
  SchoolBookTrophy: ['school-book-trophy', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M.75,23.25H5.571a1.966,1.966,0,0,0,1.929-2v-2a1.966,1.966,0,0,0-1.929-2H.75', 'M5.641,23.25H21.75a1.5,1.5,0,0,0,1.5-1.5v-3a1.5,1.5,0,0,0-1.5-1.5H5.641', 'M20.25 17.25L20.25 23.25', 'M17.25 17.25L17.25 23.25', 'M14.25 17.25L14.25 23.25', 'M11.25 17.25L11.25 23.25', 'M4.5 20.25L0.75 20.25', 'M16.2,17.25V16a.549.549,0,0,0-.388-.513A3.743,3.743,0,0,1,13.2,11.75c0-3.789,4.651.945,4.8-10.435A.586.586,0,0,0,17.4.75H6.6a.586.586,0,0,0-.6.565c.148,11.38,4.8,6.646,4.8,10.435a3.743,3.743,0,0,1-2.614,3.741A.548.548,0,0,0,7.8,16V17.25Z', 'M6.023,2.25H3.55A.536.536,0,0,0,3,2.826c.131,1.379.774,4.752,3.925,4.673', 'M17.977,2.25h2.542a.535.535,0,0,1,.547.576c-.132,1.389-.783,4.8-3.992,4.67']],
  SchoolTestPhysicalEducation: ['school-test-physical-education', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M6.75,17.25h-2.3A3.682,3.682,0,0,1,.75,13.583V3.98A3.183,3.183,0,0,1,3.512.766,3.046,3.046,0,0,1,5.188,6.535a8.712,8.712,0,0,1,0,6.437,6.794,6.794,0,0,1,10.668-1.838', 'M20.25 18.375L20.25 22.333 17.25 23.25 14.25 22.333 14.25 18.375', 'M23.25 17.25L17.25 15 11.25 17.25 17.25 19.5 23.25 17.25z', 'M11.25 17.25L11.25 20.25']],
  SchoolLocker2: ['school-locker-2', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 2.250 L23.250 2.250 L23.250 21.750 L0.750 21.750 Z', 'M3.75 18L5.25 18', 'M3.75 15L5.25 15', 'M3.75 8.25L5.25 8.25', 'M3.75 5.25L5.25 5.25', 'M8.25 2.25L8.25 21.75', 'M11.25 18L13.5 18', 'M11.25 15L13.5 15', 'M11.25 8.25L13.5 8.25', 'M11.25 5.25L13.5 5.25', 'M16.5 2.25L16.5 21.75', 'M16.5 10.5L23.25 10.5', 'M19.5,15.75h3.75a0,0,0,0,1,0,0v5a1,1,0,0,1-1,1H19.5a0,0,0,0,1,0,0v-6A0,0,0,0,1,19.5,15.75Z', 'M16.5,6h2.75a1,1,0,0,1,1,1v3.5a0,0,0,0,1,0,0H16.5a0,0,0,0,1,0,0V6A0,0,0,0,1,16.5,6Z', 'M20.25 15.75L20.25 14.25']],
  SchoolTestArt1: ['school-test-art-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M12.75 8.625L12.75 12.583 9.75 13.5 6.75 12.583 6.75 8.625', 'M15.75 7.5L9.75 5.25 3.75 7.5 9.75 9.75 15.75 7.5z', 'M3.75 7.5L3.75 10.5', 'M22.77,5.807c-1.308,1.975-4.181,1.415-5.3,3.161a2.759,2.759,0,1,0,4.648,2.974A6.5,6.5,0,0,0,22.77,5.807Z', 'M11.814,22.928a2.037,2.037,0,0,1-.525-2.948l6.231-7.963a2.772,2.772,0,0,0,1.852,1.165L14.711,22.17A2.038,2.038,0,0,1,11.814,22.928Z', 'M8.25,22.5h-6A1.5,1.5,0,0,1,.75,21V2.25A1.5,1.5,0,0,1,2.25.75H18a1.5,1.5,0,0,1,1.5,1.5V4.5']],
  SchoolTestArt: ['school-test-art', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M19.11,10.958C20.917,5.607,16.2.75,10.125.75,4.947.75.75,4.285.75,8.645c0,3.287,2.388,6.1,5.781,7.284a2.793,2.793,0,0,0,3.714-2.121A2.933,2.933,0,0,1,14.456,11.9', 'M4.500 10.500 A1.500 1.500 0 1 0 7.500 10.500 A1.500 1.500 0 1 0 4.500 10.500 Z', 'M6.750 5.250 A1.500 1.500 0 1 0 9.750 5.250 A1.500 1.500 0 1 0 6.750 5.250 Z', 'M12.750 6.750 A1.500 1.500 0 1 0 15.750 6.750 A1.500 1.500 0 1 0 12.750 6.750 Z', 'M20.25 18.375L20.25 22.333 17.25 23.25 14.25 22.333 14.25 18.375', 'M23.25 17.25L17.25 15 11.25 17.25 17.25 19.5 23.25 17.25z', 'M11.25 17.25L11.25 20.25']],
  SchoolBuilding: ['school-building', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M7.5,23.25H.75V15a1.5,1.5,0,0,1,1.5-1.5H7.5', 'M16.5,13.5h5.25a1.5,1.5,0,0,1,1.5,1.5v8.25H16.5', 'M13.5,19.313A1.416,1.416,0,0,0,12,18a1.416,1.416,0,0,0-1.5,1.313V23.25h3Z', 'M12 6.75L12 0.75', 'M12,.75h4a.5.5,0,0,1,.5.5v2a.5.5,0,0,1-.5.5H12a0,0,0,0,1,0,0v-3A0,0,0,0,1,12,.75Z', 'M10.533 11.283 A1.467 1.467 0 1 0 13.467 11.283 A1.467 1.467 0 1 0 10.533 11.283 Z', 'M16.5,11.118A4.435,4.435,0,0,0,12,6.75a4.435,4.435,0,0,0-4.5,4.368V23.25h9Z', 'M3.75 16.5L4.5 16.5', 'M3.75 20.25L4.5 20.25', 'M19.5 16.5L20.25 16.5', 'M19.5 20.25L20.25 20.25']],
  SchoolTeacherBlind: ['school-teacher-blind', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M2.250 3.750 A3.000 3.000 0 1 0 8.250 3.750 A3.000 3.000 0 1 0 2.250 3.750 Z', 'M5.25 8.25L5.25 14.25', 'M7.5,23.25l.75-7.5h1.5v-3a4.5,4.5,0,0,0-9,0v3h1.5L3,23.25Z', 'M23.25 0.75L11.25 0.75', 'M12.75 16.5L23.25 16.5', 'M12.094,8.185a.559.559,0,0,1,0-.62A6.522,6.522,0,0,1,17.25,4.5a6.522,6.522,0,0,1,5.156,3.065.559.559,0,0,1,0,.62A6.522,6.522,0,0,1,17.25,11.25,6.522,6.522,0,0,1,12.094,8.185Z', 'M19.726 5.111L14.774 10.639']],
  SchoolTeacher: ['school-teacher', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M2.250 3.750 A3.000 3.000 0 1 0 8.250 3.750 A3.000 3.000 0 1 0 2.250 3.750 Z', 'M5.25 8.25L5.25 14.25', 'M7.5,23.25l.75-7.5h1.5v-3a4.5,4.5,0,0,0-9,0v3h1.5L3,23.25Z', 'M12.75,16.5h9a1.5,1.5,0,0,0,1.5-1.5V2.25a1.5,1.5,0,0,0-1.5-1.5H11.25']],
  SchoolTeacherF: ['school-teacher-f', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M2.250 3.750 A3.000 3.000 0 1 0 8.250 3.750 A3.000 3.000 0 1 0 2.250 3.750 Z', 'M5.25 8.25L5.25 14.25', 'M7.5,23.25l.75-7.5h1.5v-3a4.5,4.5,0,0,0-9,0v3h1.5L3,23.25Z', 'M23.25 0.75L11.25 0.75', 'M12.75 16.5L23.25 16.5', 'M16.5,12V6A1.5,1.5,0,0,1,18,4.5h1.5', 'M16.5 9L18.75 9']],
  SchoolBag: ['school-bag', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M8.5,3.75h7a4,4,0,0,1,4,4v15.5a0,0,0,0,1,0,0H4.5a0,0,0,0,1,0,0V7.75a4,4,0,0,1,4-4Z', 'M9,3.75a2.792,2.792,0,0,1,2.935-3,2.815,2.815,0,0,1,2.935,3', 'M2.707,14.25H4.5a0,0,0,0,1,0,0v9a0,0,0,0,1,0,0H2.707A1.957,1.957,0,0,1,.75,21.293V16.207A1.957,1.957,0,0,1,2.707,14.25Z', 'M19.5,14.446h1.793A1.957,1.957,0,0,1,23.25,16.4v4.891a1.957,1.957,0,0,1-1.957,1.957H19.5a0,0,0,0,1,0,0v-8.8A0,0,0,0,1,19.5,14.446Z', 'M7.500 13.500 L16.500 13.500 L16.500 20.250 L7.500 20.250 Z', 'M7.5 16.5L16.5 16.5', 'M12.75 16.5L12.75 18', 'M0.75 17.185L4.5 17.185', 'M19.5,17.25h3.75']],
  SchoolTeacherCorrect: ['school-teacher-correct', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M2.250 3.750 A3.000 3.000 0 1 0 8.250 3.750 A3.000 3.000 0 1 0 2.250 3.750 Z', 'M5.25 8.25L5.25 14.25', 'M7.5,23.25l.75-7.5h1.5v-3a4.5,4.5,0,0,0-9,0v3h1.5L3,23.25Z', 'M23.25 0.75L11.25 0.75', 'M12.75 16.5L23.25 16.5', 'M21 5.25L16.5 11.25 13.5 8.25']],
  SchoolTeacherMusic: ['school-teacher-music', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M2.250 3.750 A3.000 3.000 0 1 0 8.250 3.750 A3.000 3.000 0 1 0 2.250 3.750 Z', 'M5.25 8.25L5.25 14.25', 'M7.5,23.25l.75-7.5h1.5v-3a4.5,4.5,0,0,0-9,0v3h1.5L3,23.25Z', 'M23.25 0.75L11.25 0.75', 'M12.75 16.5L23.25 16.5', 'M18.750 10.500 A1.500 1.500 0 1 0 21.750 10.500 A1.500 1.500 0 1 0 18.750 10.500 Z', 'M12.750 12.000 A1.500 1.500 0 1 0 15.750 12.000 A1.500 1.500 0 1 0 12.750 12.000 Z', 'M21.75,10.5V5.671a1.5,1.5,0,0,0-1.864-1.455l-3,.75A1.5,1.5,0,0,0,15.75,6.421V12']],
  SchoolBookApple: ['school-book-apple', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 17.250 L23.250 17.250 L23.250 23.250 L0.750 23.250 Z', 'M3.75 20.25L15.75 20.25', 'M19.125,20.25a.375.375,0,0,1,.375-.375', 'M19.5,20.625a.375.375,0,0,1-.375-.375', 'M19.875,20.25a.375.375,0,0,1-.375.375', 'M19.5,19.875a.375.375,0,0,1,.375.375', 'M10.24.75h0c1.48,0,2.51,1.5,2.51,3.75', 'M14.861,3.75,12.75,4.5l-1.959-.75a3.03,3.03,0,0,0-3.55.442,3.749,3.749,0,0,1-1.083,5.922c.706,2.985,2.485,5.39,4.316,5.629a1,1,0,0,0,.572-.115l1.4-.7a1.078,1.078,0,0,1,.959,0l1.395.7a1.006,1.006,0,0,0,.572.115c1.989-.26,4.326-3.076,4.883-6.414C20.721,6.5,19.055,1.888,14.861,3.75Z']]
};
exports["default"] = _default;